import type { DatasetsMutatorDeleteDatasetProps } from "./datasets-mutator-delete-dataset.type";

import { useDatasetsMutatorDeleteDataset } from "./datasets-mutator-delete-dataset.hook";

const DatasetsMutatorDeleteDataset = (
  props: DatasetsMutatorDeleteDatasetProps
) => {
  useDatasetsMutatorDeleteDataset(props);

  return null;
};

export default DatasetsMutatorDeleteDataset;
